import React from "react";
import { useI18n } from "@/i18n";
import { cn } from "@/lib/utils";

const LANGS = [
  { key: "fr", label: "FR" },
  { key: "nl", label: "NL" },
  { key: "en", label: "EN" },
  { key: "de", label: "DE" },
  { key: "ro", label: "RO" },
];

export function LanguageSwitcher({ dark = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      data-testid="language-switcher"
      className={cn(
        "flex gap-0.5 rounded-full p-[3px]",
        dark ? "bg-white/20 backdrop-blur" : "bg-paper-3"
      )}
    >
      {LANGS.map((l) => {
        const active = lang === l.key;
        return (
          <button
            key={l.key}
            type="button"
            data-testid={`lang-${l.key}`}
            onClick={() => setLang(l.key)}
            className={cn(
              "rounded-full px-2.5 py-1 text-xs font-semibold transition-colors",
              active ? "bg-brand text-white" : dark ? "text-white/90" : "text-ink-3"
            )}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
